import classNames from 'classnames';
import { useState, useEffect } from 'react';
import Input from '../Input';
// eslint-disable-next-line import/no-named-as-default
import CountryCodePanel, { CountryCodePanelProps } from '../CountryCodePanel';
import styles from './style.module.scss';

interface PhoneInputProps extends Pick<CountryCodePanelProps, 'language'> {
  value?: [string, string, string?, string?];
  onChange?(value: [string, string, string?, string?]): void;
  placeholder?: string;
  inputClassName?: string;
  countryCodeClassName?: string;
  arrowClassName?: string;
  onClick?(): void;
  disabledSelect?: boolean;
  disabledInput?: boolean;
  // 脱敏
  phoneVisible?: boolean;
  hide86?: boolean;
  svgColor?: string;
  inputOnBlur?(e?: any): void;
  inputOnFocus?(e?: any): void;
  countryCodeChange?(value: [string, string, string?, string?]): void;
  handleReport?: (event: string) => void;
  handlePhoneChange?(): void;
  countryCodePanelVisibleChange?(e: boolean): void;
}

const PhoneInput = ({
  value = ['+64', '', '', ''],
  onChange,
  placeholder = '请输入手机号',
  inputClassName,
  countryCodeClassName,
  arrowClassName,
  language = 'zh',
  onClick,
  disabledSelect = false,
  disabledInput = false,
  phoneVisible = false,
  svgColor = 'black',
  inputOnBlur,
  inputOnFocus,
  countryCodeChange,
  hide86 = true,
  handleReport,
  handlePhoneChange,
  countryCodePanelVisibleChange,
}: PhoneInputProps) => {
  const [countryCodePanelVisible, setCountryCodePanelVisible] = useState(false);
  // 真实值
  const [phoneValue, setPhoneValue] = useState<string>();
  // 展示的值
  const [phoneValueShow, setPhoneValueShow] = useState<string>();

  const changeValue = (str: string) => {
    let res = str;
    const len = str.length;
    let pre3 = '';
    let last4 = '';
    pre3 = str.slice(0, 3);
    last4 = str.slice(Math.max(len - 4, 3));
    const star = Math.max(0, len - 7);
    res = pre3 + '*'.repeat(star) + last4;
    return res;
  };

  useEffect(() => {
    const valueSting = String(value[1]);
    if (valueSting && valueSting !== 'undefined') {
      const data = changeValue(valueSting);
      setPhoneValue(value[1]);
      setPhoneValueShow(data);
    } else {
      setPhoneValue('');
      setPhoneValueShow('');
    }
  }, [value]);
  // 脱敏
  const handleChange = (e: any) => {
    // 获取光标位置
    const ind = e.target.selectionStart - 1;
    // 真实值 未加密的
    let inputValue = '';
    if (phoneValue) {
      inputValue = phoneValue;
    }
    // 输入框获取的值
    const showVlue = e.target.value;
    const isAdd = showVlue.length > inputValue.length;
    const num = Math.abs(inputValue.length - showVlue.length);
    if (isAdd) {
      inputValue =
        inputValue.slice(0, ind - num + 1) + showVlue.slice(ind - num + 1, ind + 1) + inputValue.slice(ind - num + 1);
    } else {
      inputValue = inputValue.slice(0, ind + 1) + inputValue.slice(ind + num + 1);
    }
    const data = changeValue(inputValue);
    // 实际值
    setPhoneValue(inputValue);
    // 展示值
    setPhoneValueShow(data);
    onChange?.([value[0], inputValue, value?.[2], value?.[3]]);
  };

  const handleOnBlur = (e: any) => {
    if (inputOnBlur) {
      inputOnBlur(e);
    }
  };

  return (
    <div className={styles.phoneInputWrap}>
      <CountryCodePanel
        value={value[0]}
        onVisibleChange={(e) => {
          countryCodePanelVisibleChange?.(e);
          setCountryCodePanelVisible(e);
        }}
        onChange={({ code, enName, ml }) => {
          onChange?.([code, value[1], enName, ml]);
          countryCodeChange?.([code, value[1], enName, ml]);
        }}
        language={language}
        hide86={hide86}
      >
        {({ value, showPanel }) => (
          <div
            className={classNames(styles.countryCode, countryCodeClassName)}
            onClick={() => {
              handleReport?.('G_FirstOrder_FormPhoneArea_Click');
              if (!disabledSelect) {
                showPanel();
              }
            }}
          >
            <span>{value}</span>
            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={classNames(styles.arrow, arrowClassName, countryCodePanelVisible && styles.open)}
            >
              <path
                d="M10.2426 1.58639L6 5.82903L1.75736 1.58639"
                stroke={svgColor}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </CountryCodePanel>
      <Input
        type="tel"
        className={classNames(styles.phoneInput, inputClassName)}
        placeholder={placeholder}
        value={phoneVisible ? phoneValueShow : phoneValue}
        onChange={(e) => {
          handleChange(e);
          handlePhoneChange?.();
        }}
        onClick={() => {
          handleReport?.('G_FirstOrder_FormPhone_Click');
          onClick?.();
        }}
        disabled={disabledInput}
        onBlur={handleOnBlur}
        onFocus={inputOnFocus}
      />
    </div>
  );
};

export default PhoneInput;
